import type { FunctionComponent } from 'react';

export const ModalRoot: FunctionComponent = () => <div id="modal-root" />;
